/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import CurrencyService from '../../services/CurrencyService';
import CurrencyTypes from '../types/CurrencyTypes';

//* get all currency list items
function getAll(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: CurrencyTypes.GET_CURRENCY_LIST_REQUEST });
    try {
      const res = await CurrencyService.getAll(pageOption, sortData, keyword);
      dispatch({
        type: CurrencyTypes.GET_CURRENCY_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CurrencyTypes.GET_CURRENCY_LIST_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

const updateQueryParams = (paging, sorting, keyword) => ({
  type: CurrencyTypes.UPDATE_CURRENCY_QUERY_PARAMS,
  payload: { paging, sorting, keyword }
});

//* get all currency list for dropdown
function getCurrencyList() {
  return async (dispatch) => {
    dispatch({ type: CurrencyTypes.GET_ALL_CURRENCY_LIST_REQUEST });
    try {
      const res = await CurrencyService.getCurrencyList();
      dispatch({
        type: CurrencyTypes.GET_ALL_CURRENCY_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CurrencyTypes.GET_ALL_CURRENCY_LIST_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

function add(postData, setErrors, submitting, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: CurrencyTypes.ADD_CURRENCY_REQUEST });
    try {
      const res = await CurrencyService.add(postData);
      dispatch({ type: CurrencyTypes.ADD_CURRENCY_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().currency.queryParams;
      setTimeout(() => dispatch(CurrencyAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: CurrencyTypes.ADD_CURRENCY_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: CurrencyTypes.GET_CURRENCY_ITEM_REQUEST });
    try {
      const res = await CurrencyService.getItem(code);
      dispatch({
        type: CurrencyTypes.GET_CURRENCY_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CurrencyTypes.GET_CURRENCY_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData) {
  return async (dispatch, getState) => {
    dispatch({ type: CurrencyTypes.UPDATE_CURRENCY_REQUEST });
    try {
      const res = await CurrencyService.update(code, postData);
      dispatch({
        type: CurrencyTypes.UPDATE_CURRENCY_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().currency.queryParams;
      setTimeout(() => dispatch(CurrencyAction.getAll(paginationData, sortingData, keyword)), 500);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CurrencyTypes.UPDATE_CURRENCY_ERROR,
          error: error.response
        });
        // if (error.response.data && error.response.data.message) {
        //   toast.error(error.response.data.message);
        // }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: CurrencyTypes.DELETE_CURRENCY_REQUEST });
    try {
      const res = await CurrencyService.deleteItem(code);
      dispatch({
        type: CurrencyTypes.DELETE_CURRENCY_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().currency.queryParams;
      setTimeout(() => dispatch(CurrencyAction.getAll(paginationData, sortingData, keyword)), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CurrencyTypes.DELETE_CURRENCY_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getActiveItem() {
  return async (dispatch) => {
    dispatch({ type: CurrencyTypes.GET_CURRENCY_ACTIVE_REQUEST });
    try {
      const res = await CurrencyService.getActiveItem();
      dispatch({
        type: CurrencyTypes.GET_CURRENCY_ACTIVE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CurrencyTypes.GET_CURRENCY_ACTIVE_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

const CurrencyAction = {
  getAll,
  getCurrencyList,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem,
  updateQueryParams
};

export default CurrencyAction;
